<script>
export default {
  name: "ShipsPiAccidentIncident",

}
</script>

<template>
  <div>
    <div class="row mb-2 justify-content-sm-between">
      <div class="col-auto">
        <nav class="navbar navbar-expand-lg mt-2" id="ModelNav">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
                  aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item" @click="">
                <router-link
                  class="nav-link" :to="{ name: $route.name, params : {
                      feature : 'medical_type'
                    }}">
                  <span style="height: 100%">Medical Type</span>
                </router-link>
              </li>
              <li class="nav-item" @click="">
                <router-link
                  class="nav-link" :to="{ name: $route.name, params : {
                      feature : 'occupational_accidents'
                    }}">
                  <span>Occupational Accidents</span>
                </router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <router-view :key="$route.params.feature"></router-view>
  </div>
</template>

<style scoped>
#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }

  .nav-link span {
    font-size: 14px;
  }
}

.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}
</style>
